<template>
  <div>
    <form @submit.prevent="saveItem">
      <div class="form-group-row">
        <AddEditFormGroup
          label="Type"
          fieldId="selectedType"
          v-model="selectedType"
          component="select"
          :options="billingItemTypes"
          @change="onTypeChange"
        />
        <AddEditFormGroup
          v-if="explainCredit"
          label="Explanation"
          fieldId="explanation"
          v-model="explanation"
          type="string"
          component="textarea"
          @input="onExplanationInput"
        />
        <AddEditFormGroup
          v-else
          label="Sub Type"
          fieldId="selectedSubType"
          v-model="selectedSubType"
          component="select"
          :options="subTypes"
          :disabled="!selectedType"
          @change="onSubTypeSelect"
        />

        <!--        <AddEditFormGroup-->
        <!--          v-if="selectAircraft"-->
        <!--          label="Aircraft"-->
        <!--          fieldId="selectedSubType"-->
        <!--          v-model="selectedAircraft"-->
        <!--          component="select"-->
        <!--          :options="subTypes"-->
        <!--          :disabled="!selectedType"-->
        <!--        />-->
      </div>
      <div class="form-group-row">
        <AddEditFormGroup
          label="Quantity"
          fieldId="quantity"
          v-model="localItem.quantity"
          type="number"
          step="any"
        />
        <AddEditFormGroup
          label="Price"
          fieldId="price"
          v-model="itemChargeRate"
          type="number"
          step="any"
          :value="itemChargeRate"
          v-show="priceFieldVisible"
        />
      </div>
      <div class="modal-actions">
        <hilo-button label="Save" styleType="blue" type="submit" modalButton />
      </div>
    </form>
  </div>
</template>

<script>
import HiloButton from "@/components/HiloComponents/HiloButton.vue";
import AddEditFormGroup from "@/pages/Dashboard/HiloPages/AddEditPages/AddEditFormGroup.vue";
import BillingAPIService from "src/servicehandlers/BillingAPIService";
import AircraftAPIService from "src/servicehandlers/AircraftAPIService";
import ActiveInstructorsAPIService from "src/servicehandlers/ActiveInstructorsAPIService";
const billingAPIService = new BillingAPIService();
const aircraftAPIService = new AircraftAPIService();
const activeInstructorsAPIService = new ActiveInstructorsAPIService();

export default {
  components: { AddEditFormGroup, HiloButton },
  props: {
    item: Object,
  },
  data() {
    return {
      localItem: this.item
        ? { ...this.item }
        : { name: "", quantity: 1, price: 0 },
      billingItemTypes: [],
      subTypes: [],
      aircraft: [],
      instructors: [],
      fixedCostItems: [],
      selectedType: null,
      itemChargeRate: 0,
      explainCredit: false,
      explanation: null,
      selectAircraft: false,
      selectedAircraft: null,
      selectInstructor: false,
      selectedInstructor: null,
      selectFixedCostItem: false,
      selectedFixedCostItem: null,
      selectedSubType: null,
      priceFieldVisible: true,
    };
  },
  methods: {
    async getBillingItemTypes() {
      try {
        this.billingItemTypes = await billingAPIService.getBillingItemTypes();
      } catch (error) {}
    },
    async onTypeChange(value) {
      this.itemChargeRate = null;
      this.selectAircraft = false;
      this.selectedAircraft = null;
      this.selectInstructor = false;
      this.selectedInstructor = null;
      this.selectFixedCostItem = false;
      this.selectedFixedCostItem = null;
      this.explainCredit = false;

      // Find the billingItemType that was selected
      const selectedItem = this.billingItemTypes.find(
        (type) => type.id === value,
      );
      if (!selectedItem) {
        return;
      }

      const itemTypeName = selectedItem.name;
      this.localItem.name = `<div>${itemTypeName}<br>`;
      switch (itemTypeName) {
        case "Aircraft Rental":
          //Select aircraft
          this.selectAircraft = true;
          await aircraftAPIService.get().then((response) => {
            this.subTypes = response.map((item) => {
              return {
                ...item,
                aircraftStatus: item.aircraftStatus?.name,
                name: `${item.tailNumber} ${item.model}`,
              };
            });
          });
          this.aircraft = this.subTypes;
          break;
        case "Credit":
          //Input explanation
          this.explainCredit = true;
          break;
        case "Flight Instruction":
          //Select Instructor
          this.selectInstructor = true;
          await activeInstructorsAPIService.get().then((response) => {
            this.subTypes = response.map((item) => {
              return {
                ...item,
                firstName: item.user.firstName,
                lastName: item.user.lastName,
                name: `${item.user.firstName} ${item.user.lastName}`,
              };
            });
          });
          this.instructors = this.subTypes;
          break;
        case "Ground Instruction":
          //Select Instructor
          this.selectInstructor = true;
          await activeInstructorsAPIService.get().then((response) => {
            this.subTypes = response.map((item) => {
              return {
                ...item,
                firstName: item.user.firstName,
                lastName: item.user.lastName,
                name: `${item.user.firstName} ${item.user.lastName}`,
              };
            });
          });
          this.instructors = this.subTypes;
          break;
        default:
          this.selectFixedCostItem = true;
          await billingAPIService
            .getFixedCostItemsByItemType(value)
            .then((response) => {
              this.subTypes = response;
              this.fixedCostItems = this.subTypes;
            });
          break;
      }
    },
    async onSubTypeSelect(value) {
      let selectedItem;

      if (this.selectAircraft) {
        selectedItem = this.aircraft.find((type) => type.id === value);
        this.selectedAircraft = selectedItem;
        this.itemChargeRate = selectedItem.chargeRate;
        this.localItem.name += `${selectedItem.name}</div>`;
      } else if (this.selectInstructor) {
        selectedItem = this.instructors.find((type) => type.id === value);
        this.selectedInstructor = selectedItem;
        this.itemChargeRate = selectedItem.chargeRate;
        this.localItem.name += `${selectedItem.name}</div>`;
      } else if (this.selectFixedCostItem) {
        selectedItem = this.fixedCostItems.find((type) => type.id === value);
        this.selectedFixedCostItem = selectedItem;
        this.itemChargeRate = selectedItem.cost; //TODO this column name should get updated in the table
        this.localItem.name += `${selectedItem.name}</div>`;
      } else if (this.explanation) {
        // TODO Price box doesn't show up
        selectedItem = value;
        this.explanation = value;
        this.itemChargeRate = 0;
        this.localItem.name += `${this.explanation}</div>`;
      }
    },
    onExplanationInput(value) {
      this.explanation = value;
      this.localItem.name = `<div>${
        this.billingItemTypes.find((type) => type.id === this.selectedType)
          ?.name || ""
      }<br>${this.explanation}</div>`;
    },
    saveItem() {
      this.localItem.price = this.itemChargeRate;
      const payload = {
        ...this.localItem,
        type: this.selectedType,
        subType: this.selectedSubType,
      };
      this.$emit("save", payload);
    },
  },
  mounted() {
    this.getBillingItemTypes();
  },
};
</script>

<style scoped>
.form-group-row {
  display: flex;
  gap: 16px;
}
.form-group {
  flex: 1;
}
.modal-actions {
  display: flex;
  justify-content: space-between;
}
</style>
